import { render } from "./MinimalExercisePreview.vue?vue&type=template&id=6f65333a&ts=true"
import script from "./MinimalExercisePreview.vue?vue&type=script&lang=ts"
export * from "./MinimalExercisePreview.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__